import barba from '@barba/core';
import tippy from 'tippy.js';
import Cookies from 'js-cookie';
import { throttle } from './helpers/throttle';
import { toggleDarkmode } from "./helpers/darkmode";

const initDarkmode = () => {
	const darkmode = document.querySelector('.header__darkmode');
	const isDarkmode = () => document.body.classList.contains('darkmode');
	const flashTipTimeouts = [];

	if (Cookies.get('darkmode') === undefined) {
		const prefersDarkmode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
		Cookies.set('darkmode', prefersDarkmode ? 'true' : 'false', { path: window.wkDarkmode.cookiepath, domain: window.wkDarkmode.cookiedomain });
		if (prefersDarkmode) {
			document.body.classList.add('darkmode');
		}
	}

	const tip = tippy(darkmode, {
		content: isDarkmode() ? wkDarkmode.tip_darkmode : wkDarkmode.tip_lightmode,
		allowHTML: true,
		touch: false,
		onTrigger: () => {
			flashTipTimeouts.forEach((timeout) => clearTimeout(timeout));
		},
	});

	const maybeFlashTip = () => {
		if (Cookies.get('tip-flashed') === undefined && !document.body.classList.contains('home')) {
			Cookies.set('tip-flashed', 'true', { expires: 7, path: window.wkDarkmode.cookiepath, domain: window.wkDarkmode.cookiedomain });
			flashTipTimeouts.push(setTimeout(() => tip.show(), 2000));
			flashTipTimeouts.push(setTimeout(() => tip.hide(), 7000));
		}
	};

	const toggle = () => {
		toggleDarkmode();
		Cookies.set('darkmode', isDarkmode() ? 'true' : 'false', { expires: 30, path: window.wkDarkmode.cookiepath, domain: window.wkDarkmode.cookiedomain });
		setTimeout(() => {
			tip.setContent(isDarkmode() ? wkDarkmode.tip_darkmode : wkDarkmode.tip_lightmode);
		}, 500);
	};

	darkmode.addEventListener('click', throttle(500, toggle));
	window.addEventListener('cookie-consent', maybeFlashTip);
	barba.hooks.afterEnter(maybeFlashTip);
};

document.addEventListener('DOMContentLoaded', () => {
	setTimeout(initDarkmode, 200);
});
